import { render, staticRenderFns } from "./updates.vue?vue&type=template&id=c7bedba4&scoped=true&"
import script from "./updates.vue?vue&type=script&lang=ts&"
export * from "./updates.vue?vue&type=script&lang=ts&"
import style0 from "./updates.vue?vue&type=style&index=0&id=c7bedba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bedba4",
  null
  
)

component.options.__file = "updates.vue"
export default component.exports